import React from "react";
import PropTypes from "prop-types";
import UIChip from "../UIChip";
import { clx } from "../../../utils/Helpers";
import { getStatusTagConfig } from "./statusTagStyles";
import "./_UIStatusTag.scss";

const UIStatusTag = ({
  status,
  label,
  preset,
  tone,
  variant = "soft",
  className = "",
  sx,
  style,
  ...props
}) => {
  const config = getStatusTagConfig({ status, preset, tone, variant });
  const statusCssVars = {
    "--status-tag-bg": config.style.background,
    "--status-tag-border": config.style.borderColor,
    "--status-tag-color": config.style.color,
    ...style,
  };

  return (
    <UIChip
      label={label || config.label}
      color="default"
      className={clx(
        "ui-status-tag",
        `ui-status-tag--${config.variant}`,
        `ui-status-tag--${config.preset}`,
        `ui-status-tag--${config.key}`,
        className
      )}
      style={statusCssVars}
      sx={sx}
      {...props}
    />
  );
};

UIStatusTag.propTypes = {
  status: PropTypes.string.isRequired,
  label: PropTypes.node,
  preset: PropTypes.oneOf(["table", "header"]),
  tone: PropTypes.string,
  variant: PropTypes.oneOf(["soft", "solid"]),
  className: PropTypes.string,
  style: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array]),
};

UIStatusTag.defaultProps = {
  label: undefined,
  preset: undefined,
  tone: undefined,
  variant: "soft",
  className: "",
  style: undefined,
  sx: undefined,
};

export default UIStatusTag;
